import React from 'react';
import { motion } from 'framer-motion';
import { Check, Calendar } from 'lucide-react';
export function SystemSection() {
  const weeks = [{
    week: 'Semana 1',
    title: 'FUNDAMENTOS DE ACERO',
    description: 'Diagnóstico mental, establecimiento de rutinas base y primeros ejercicios de concentración',
    color: 'border-l-4 border-[#2B7FD4]'
  }, {
    week: 'Semana 2',
    title: 'CONSTRUCCIÓN DE FUERZA',
    description: 'Incremento progresivo de la carga mental, técnicas anti-distracción y gestión del tiempo',
    color: 'border-l-4 border-[#F97316]'
  }, {
    week: 'Semana 3',
    title: 'RENDIMIENTO DE ÉLITE',
    description: 'Integración total del sistema, optimización del entorno y plan de mantenimiento de por vida',
    color: 'border-l-4 border-[#1B3A6B]'
  }];
  return <section className="py-20 bg-white relative" data-id="element-126">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-128">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold text-[#1B3A6B] mb-4 uppercase" data-id="element-129">
            El Sistema de 21 Días
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-[#2B7FD4] font-medium" data-id="element-130">
            Cada semana construye sobre la anterior, creando hábitos que duran
            toda la vida.
          </motion.p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6" data-id="element-131">
          {weeks.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className={`bg-[#F8FAFC] p-6 sm:p-8 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ${item.color} flex flex-col sm:flex-row gap-6 items-start sm:items-center`} data-id="element-132">
              <div className="flex-shrink-0 bg-white p-4 rounded-full shadow-sm border border-slate-100" data-id="element-133">
                <Calendar className="h-8 w-8 text-[#1B3A6B]" data-id="element-134" />
              </div>

              <div className="flex-1" data-id="element-135">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2" data-id="element-136">
                  <span className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-137">
                    {item.week}
                  </span>
                  <h3 className="text-xl font-bold text-[#1B3A6B] uppercase" data-id="element-138">
                    {item.title}
                  </h3>
                </div>
                <p className="text-slate-600 text-lg" data-id="element-139">{item.description}</p>
              </div>

              <div className="hidden sm:block" data-id="element-140">
                <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-141">
                  <Check className="h-6 w-6 text-green-600" data-id="element-142" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}